<template>
  <card-seplag titulo="Cadastro de Usuários">
    <!-- TABELA COM OS ELEMENTOS
    
        :onAdicionarDado="() => abrirBuscaUsuario()"
         -->
      <table-seplag
        :dados="usuarios.content"
        :totalRegistro.sync="totalregistro"
        urlPanagicao = 'seguranca/contasacesso'
        :hasExibirCabecalho="true"
        :campos="camposTabelaBens" 
        :onEditarDado="abrirBuscaUsuario"
        :onSearchPaginacao="paginacaodabusca"
        :rows="10"
        :paginacao="true"
        placeholderSearch="Digite o Nome do Usuário"
        :onSearch="search"
        cols="12"
        v-if="usuarios"
      >
      </table-seplag>
  <!-- DIALOG -->
    <Dialog
      :visible.sync="exibirModalsuario"
      :contentStyle="'max-width:80rem; max-height:40rem; width:80rem;'"
      :modal="true"
      header="Cadastro"
    >
      <div class="p-grid p-fluid" style="">
        

        <div class="p-col-4 p-md-4" v-if="!registro.id">
          <Button
            label="Cadastrar"
            class="p-button-info"
            icon="pi pi-check"
            @click="cadastrarUsuario()"
          />
        </div>
        <div class="p-col-4 p-md-4" v-if="registro.id">
          <Button
            label="Salvar"
            class="p-button-warning"
            icon="pi pi-user-edit"
            @click="atualizarUsuario()"
          />
        </div>
      </div>
    </Dialog>
  
  
  </card-seplag>

</template>
<script>
import CardSeplag from "@/template/CardSeplag.vue";
import { baseApiUrl} from "@/config/global";
import TableSeplag from "@/template/TableSeplag.vue";
const getCadastroPessoa = () => {
  return {
    ativoConta: "S",
    nomeApresentacao: "",
    login: "",
    trocarSenha:'S',
    id: 0,
    pessoa: {
      nomePessoa: "",
      numrCpf: "",
      dataNascimento: "",
      flagSexo: null,
      descEmail: "",
      numrTelefonePessoal: null,
      numrTelefoneComercial: null,
      numrTelefoneCelular: null,
      endrTipoLogradouro: "",
      endrLogradouro: "",
      endrBairro: "",
      endrComplemento: "",
      numrCep: "",
      endrNumero: "",
      cidadeEnd: null,
      ufRg: null,
      statPessoa: 1,
      flagOrigem: "DECLARACAOBENS",
      flagServidor: "N",
      servidor: null
    },
    perfis: [],
    
  };
};
export default {
  name: "cadastroUsuario",
  components: { CardSeplag, TableSeplag},
  // componente que tem que ser adicionado se for usar o tabpaneldados
  // TabPanelPerfilAcesso 
  model: {
    prop: "exibirModalPerfil",
    event: "change",
  },
  props: {
    data: {
      type: Object,
    },
  },
  data: function () {
    return {
      registro: getCadastroPessoa(),
      exibirModalsuario: false,
      messagemUsuario: false,
      loadingListUsuario: false,
      selectUsers: null,
      inputBusca: null,
      usuarios: null,
      usuariosBusca: null,
      nomeDialogo: null,
      sexo: false,
      dadosVinculoPessoa: [],
      perfilSelect: null,
      camposTabelaBens: [
        { titulo: "Nome", nome: "pessoa.nomePessoa"},
        { titulo: "CPF", nome:"pessoa.cpfFormatado"},
        { titulo: "Email", nome:"pessoa.descEmail"},
        { titulo: "Login", nome:"login"},
        
      ],
      perfilSelecionado: null,
      autorizacaoSelecionada: [],
      contaacesso: null,
      totalregistro:0,
      elementofiltrado:null,
      cities: [],
    };
  },

  //  CONEXÃO COM A API
  methods: {
    carregarDados() {
      this.$http.get(`${baseApiUrl}/seguranca/contasacesso?page=0&size=10`).then((res) => {
        this.usuarios = res.data;
        this.totalregistro = this.usuarios.totalElements;
      });          
      
    },  
    
    paginacaodabusca(rows,page){
      if (this.elementofiltrado!=null){
        this.$http.post(`${baseApiUrl}/seguranca/contasacesso/buscarNome?size=${rows}&page=${page}`, JSON.stringify(this.elementofiltrado)).then(res =>{
          this.usuarios = res.data
          this.totalregistro = this.usuarios.totalElements;
        })
      } else {
        this.$http.get(`${baseApiUrl}/seguranca/contasacesso?size=${rows}&page=${page}`).then(res1=>{
          this.usuarios = res1.data
          this.totalregistro = this.usuarios.totalElements;
        })
      }
  },
  
  
  async abrirBuscaUsuario(dados = null) {
    if (dados) { 
      /*if (!dados.pessoa.servidor) {
          dados.pessoa.servidor = {
            numrMatricula: null
          }
      }*/
      
      this.registro =  JSON.parse(JSON.stringify(dados))
      this.$http.get(`${baseApiUrl}/seguranca/contasacesso/${this.registro.id}/perfis `).then(res =>{
          if(res.data.length > 0){
            let perfisAcessoUsuario = []
            for(let i=0;i<res.data.length;i++){
                perfisAcessoUsuario.push({                         
                    contaAcesso: this.registro.id,
                    perfilAcesso: res.data[i]
                })
            }
            this.registro.perfis = perfisAcessoUsuario
          }
      });
      this.$router.push({name:'usuarioContainer', params : {data : this.registro} })
      //this.exibirModalsuario = true;
      //containerUsuario
    } else {
      this.registro = getCadastroPessoa();
      this.$router.push({name:'usuarioContainer', params : {data : this.registro} })
      //this.exibirModalsuario = true;
    }
  },
  
  /*atualizarUsuario() {
    let jsonPost = {...this.registro};
    jsonPost.pessoa.numrTelefonePessoal = jsonPost.pessoa.numrTelefonePessoal.replace( "(", "" );
    jsonPost.pessoa.numrTelefonePessoal = jsonPost.pessoa.numrTelefonePessoal.replace(")", "" );
    jsonPost.pessoa.numrTelefonePessoal = jsonPost.pessoa.numrTelefonePessoal.replace("-", "" );
    jsonPost.pessoa.numrTelefoneCelular = jsonPost.pessoa.numrTelefoneCelular.replace("(", "" );
    jsonPost.pessoa.numrTelefoneCelular = jsonPost.pessoa.numrTelefoneCelular.replace(")", "" );
    jsonPost.pessoa.numrTelefoneCelular = jsonPost.pessoa.numrTelefoneCelular.replace("-", "" );
    jsonPost.pessoa.numrCpf = jsonPost.pessoa.numrCpf.replace(".", "");
    jsonPost.pessoa.numrCpf = jsonPost.pessoa.numrCpf.replace(".", "");
    jsonPost.pessoa.numrCpf = jsonPost.pessoa.numrCpf.replace(".", "");
    jsonPost.pessoa.numrCpf = jsonPost.pessoa.numrCpf.replace("-", "");
    let atualizando = { 
      ativoConta : jsonPost.ativoConta,
      nomeApresentacao : jsonPost.nomeApresentacao,
      login : jsonPost.login,
      trocarSenha: jsonPost.trocarSenha,
      perfis: jsonPost.perfis,
      pessoa: jsonPost.pessoa       
    }
    this.$http
      .put(`${baseApiUrl}/seguranca/contasacesso/${this.registro.id}`, JSON.stringify(atualizando))
      .then(() => {
          printToast({severity: 'success', summary: 'Sucesso', detail: 'atualizado com sucesso'})
          this.carregarDados()
          this.exibirModalsuario = false;
      });

      
  },*/
  search(filtro){        
    if(filtro != ''){
        
      let postBody = {
            nome: filtro,
            pesquisarTodoNome: true
      }
      this.elementofiltrado = postBody
      this.$http.post(`${baseApiUrl}/seguranca/contasacesso/buscarNome?page=0&size=10`, JSON.stringify(postBody)).then(res => {
        this.usuarios= res.data
        this.totalregistro = this.usuarios.totalElements;
      })
    }else{
        this.$http.get(`${baseApiUrl}/seguranca/contasacesso?size=10&page=0`).then(res1=>{
        this.usuarios = res1.data
        this.totalregistro = this.usuarios.totalElements;
      })
    }
	},
},
  mounted() {
    this.carregarDados();
  },
};
</script>

<style scoped>

.sm-visible {
  display: none;
}
.textWrap {
  word-wrap: break-word;
}
.button-cadasdastrar {
  font-size: 13px;
}
.button-buscar {
  font-size: 13px;
}
#teste {
  background-color: red;
}

@media screen and (max-width: 40em) {
  .sm-invisible {
    display: none;
  }

  .sm-visible {
    display: inline;
    margin-right: 0.5rem;
  }
}
</style>
